import React, { ReactNode } from 'react';
import { createNullableContext } from '../../core/context/create-nullable-context';

type AccentBgContextValue = {
  isAccentBackground: boolean;
};

const [AccentBgContext, useAccentBgContext] = createNullableContext<AccentBgContextValue>('AccentBgContext');

type Props = {
  children: ReactNode;
  isAccentBackground?: boolean;
};

export const AccentBgProvider: React.FC<Props> = ({ children, isAccentBackground = false }) => {
  return <AccentBgContext.Provider value={{ isAccentBackground }}>{children}</AccentBgContext.Provider>;
};

export { AccentBgContext, useAccentBgContext };
